module.exports = __webpack_public_path__ + "img/drink-bottle.76153765.svg";